import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import { getProfileSetting } from "./thunkAction";

const initialState = {
  profileSetting: {},
  loading: false,
  error: null,
};

const profileSettingSlice = createSlice({
  name: "profileSettingManage",
  initialState,
  reducers: {
    clearProfileSetting(state) {
      state.profileSetting = {};
    },
    resetProfileError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // getProfileSetting
      .addCase(getProfileSetting.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProfileSetting.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.profileSetting = _.get(action, "payload", {});
      })
      .addCase(getProfileSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const profileSettingReducer = profileSettingSlice.reducer;

export const profileSettingAction = profileSettingSlice.actions;
